import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function shareReducer(state = initialState.shareCounts, action) {
  switch (action.type) {
    case types.ADD_SHARE_COUNT_SUCCESS:
      return {
        ...state,
        [action.shareType]: action.shareCount,
        loaded: true,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./library/app/reducers/shareReducer.js